import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("khevora_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      localStorage.removeItem("khevora_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithToken = (token, userData) => {
    localStorage.setItem("khevora_token", token);
    setUser(userData);
  };

  const login = async (identifier, password) => {
    const res = await api.post("/auth/login", { identifier, password });
    loginWithToken(res.data.token, res.data.user);
    return res.data.user;
  };

  const signupStart = async (payload) => {
    const res = await api.post("/auth/signup/start", payload);
    return res.data;
  };

  const signupVerify = async (email, code) => {
    const res = await api.post("/auth/signup/verify", { email, code });
    loginWithToken(res.data.token, res.data.user);
    return res.data.user;
  };

  const resendOtp = async (email) => {
    const res = await api.post("/auth/signup/resend", { email });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("khevora_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, signupStart, signupVerify, resendOtp, logout, loginWithToken, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
